








import { defineComponent, ref } from '@vue/composition-api';
import Input from '@/views/Input.vue';

export default defineComponent({
  components: { Input },
  name: 'DownloadButton',
  props: { blok: { type: Object } },
  setup() {
    const copyDownloadURL = ref();

    function copyLink() {
      copyDownloadURL.value.select();
      copyDownloadURL.value.setSelectionRange(0, 99999); /* For mobile devices */
      document.execCommand('copy');
    }

    return {
      copyLink,
      copyDownloadURL,
    };
  },
});
